module.exports = new __parcel__URL__("slack@2x.e780b3e9.png").toString();